<template>
  <div>
    <!-- Loading -->
    <!-- Formulario -->
    <div v-if="!loadingTable">
      <!-- Titulo -->
      <div
        class="d-flex align-items-center justify-content-between"
        style="margin-top: -20px"
      >
        <!-- Contenido izq -->
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center justify-content-between">
            <h6 style="margin: 0px !important">
              Nueva solicitud de reserva no planificada
            </h6>

            <i
              class="fas fa-info-circle ml-2 girarObjeto pulsoAmarillo"
              title="Para continuar con la solicitud, por favor ingrese los siguientes datos."
              style="cursor: help"
            ></i>
          </div>
        </div>

        <!-- Contenido der (Buscador para cargar reserva anterior) -->
        <div class="d-flex align-items-center">
          <ui-textbox
            class="mr-2"
            style="margin-bottom: 0px !important; width: 130% !important"
            placeholder="ID Reserva anterior"
            v-model="id_reserva_booking"
            ref="textUtilizarReservaAnterior"
            :autofocus="focusUtilizarReservaAnterior"
            @keydown-enter="showFormEdit()"
            v-if="mostrarBuscarBooking"
          />

          <div class="d-flex" style="margin-top: 10px">
            <Button
              class="mr-1"
              style="margin-bottom: 0px !important"
              color="#dc9135"
              colorText="#fff"
              :height="25"
              icon="fas fa-search"
              title="Buscar reserva"
              round
              @click.native="showFormEdit()"
              v-if="mostrarBuscarBooking"
            />

            <!-- text="Utilizar Reserva Anterior" -->
            <!-- round -->
            <Button
              color="#dc3545"
              colorText="#fff"
              :height="25"
              :width="205"
              icon="fas fa-sync"
              title="Utilizar Reserva Anterior"
              text="Utilizar Reserva Anterior"
              :active="mostrarBuscarBooking"
              horizontal
              @click.native="showFormUtilizarReservaAnterior()"
            />
          </div>
        </div>
      </div>

      <!-- cuerpo (Formulario) -->
      <div class="mt-4">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Año"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="anioFilter"
            v-model="formulario.anioModel"
            @change="validacionFormulario"
          ></ui-select>

          <ui-select
            class="w-50"
            has-search
            label="Semana"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="semanaFilter"
            v-model="formulario.semanaModel"
            @change="validacionFormulario"
          ></ui-select>
        </div>

        <!-- Fila 1.1 -->
        <div class="d-flex" v-if="isAdmin">
          <!-- Empresa -->
          <ui-select
            class="w-100"
            has-search
            label="Empresa"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="formulario.empresa"
            @change="validacionFormulario"
            :options="listaClientesUsuarioActual"
          ></ui-select>
        </div>

        <!-- Fila 2 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Contenedor"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="contenedoresFilter"
            v-model="formulario.contenedoresModel"
            @change="validacionFormulario"
          ></ui-select>

          <ui-textbox
            class="w-50"
            floating-label
            :min="1"
            type="number"
            label="Cantidad de contenedores"
            v-model="formulario.cantidadContenedoresModel"
            @change="validacionFormulario"
          />
        </div>

        <!-- Fila 2 -->
        <div class="d-flex">
          <ui-select
            class="w-100"
            has-search
            label="Puerto de descarga "
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="puertosFilter"
            v-model="formulario.puertosModel"
            @change="validacionFormulario"
          ></ui-select>
        </div>
      </div>
    </div>

    <div v-else>
      <loading style="padding-top: 65px !important" />
    </div>

    <booking-utilizar-reserva-anterior-component
      :booking="booking"
      :load="load"
      :cerrarModal="cerrarModal"
      :closeModall="closeModall"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Keen UI
import UiTextbox from "keen-ui/lib/UiTextbox";
import UiSelect from "keen-ui/lib/UiSelect";

import {
  getBookingsNoPlanificados,
  verBooking,
  getBookingIdBycountry,
} from "../../../constants/lineas";
import Button from "../Button";
import Loading from "../loading";
import { bookingInitialValue } from '../../../helpers/lineas/bookings/initialValues';
import { serializeBooking } from '../../../helpers/lineas/bookings/bookingHelper.js';
import BookingUtilizarReservaAnteriorComponent from "./BookingUtilizarReservaAnteriorComponent";

export default {
  props: ["cerrarModal", "closeModall"],
  data() {
    return {
      formulario: {
        anioModel: [],
        semanaModel: [],
        contenedoresModel: [],
        cantidadContenedoresModel: "",
        puertosModel: [],
        empresa: [],
      },
      isLoading: false,
      anioFilter: [],
      semanaFilter: [],
      contenedoresFilter: [],
      puertosFilter: [],
      id_reserva_booking: "",
      mostrarBuscarBooking: false,
      focusUtilizarReservaAnterior: false,
      load: false,
      booking: bookingInitialValue
    };
  },

  components: {
    UiTextbox,
    UiSelect,
    Button,
    Loading,
    BookingUtilizarReservaAnteriorComponent,
  },

  computed: {
    ...mapState(["loadingTable", "isAdmin", "listaClientesUsuarioActual"]),
  },

  methods: {

    ...mapActions(["ActionSetZindexModal"]),

    ...mapActions("lineas", [
      "actionSetEstadoSolicitudReservaPlanificada",
      "actionSetFormularioSolicitudNoPlanificada",
      "actionSetDataAnios",
      "actionSetDataSemanas",
      "actionSetDataContenedores",
      "actionSetDataPuertoDescarga",
      "actionSetDataserviciosIntegrales",
      "actionSetDataShippers",
      "actionSetDataShippersAddress",
      "actionSetDataProducts",
      "actionSetDataMetodosPago",
      "actionSetDataTarifaContrato",
      "actionSetListaProductosExportar",
      "actionSetListaShipper",
      "actionSetListaDireccionesShipper",
      "actionSetListaPacking",
      "actionSetListaConsignatarios",
      "actionSetListaNotificados",
      "actionSetListaAtmosferas",
      "ActionSetVisibleModalUtilizarReservaAnterior",
      "actionSetShippers"
    ]),

    showFormUtilizarReservaAnterior() {
      this.mostrarBuscarBooking = !this.mostrarBuscarBooking;
      this.focusUtilizarReservaAnterior = true;
    },

    async showFormEdit() {
      if (!this.id_reserva_booking) return;

      const idByCountry = parseInt(this.id_reserva_booking.trim());

      if (Number.isNaN(idByCountry)) return;

      try {
        this.$vToastify.loader("Buscando Booking...");
        this.load = true;
        const { data } = await getBookingIdBycountry(idByCountry);

        if (!data.status) {
          this.load = false;
          this.$vToastify.error("Booking no encontrado");
          return this.$vToastify.stopLoader();
        }

        
        this.booking = await this.getDataOrderBooking(data.data.booking_id);
        this.$vToastify.stopLoader();
        this.ActionSetVisibleModalUtilizarReservaAnterior(true);
        this.load = false;
        this.mostrarBuscarBooking = false ;
        this.id_reserva_booking = "";
      } catch (error) {
        this.$vToastify.stopLoader();
        this.$vToastify.error("Booking no encontrado");
      }
    },
    async getDataOrderBooking(id) {
      const booking = await verBooking(id);
      return serializeBooking(booking);
    },
    async getDataFormulario() {
      this.isLoading = true;
      let data = await getBookingsNoPlanificados();
      this.anioFilter = data.filtroAnios;
      this.semanaFilter = data.filtroSemanas;
      this.contenedoresFilter = data.filtro_contenedores;
      this.puertosFilter = data.filtro_puertos;

      // Deja seleccionado el ultimo valor del array años
      const date = new Date();
      this.formulario.anioModel = {
        id: date.getFullYear().toString(),
        name: date.getFullYear().toString(),
      };

      // Deja seleccionado el ultimo valor del array semanas
      this.formulario.semanaModel = data.filtroSemanas[0];
      this.actionSetDataAnios(data.filtroAnios);
      this.actionSetDataSemanas(data.filtroSemanas);
      this.actionSetDataContenedores(data.filtro_contenedores);
      this.actionSetDataPuertoDescarga(data.filtro_puertos);

      // formularios
      this.actionSetDataShippers(data.filtroShippers);
      this.actionSetDataShippersAddress(data.filtroShippersAddress);
      this.actionSetDataProducts(data.filtroProducts);
      this.actionSetDataMetodosPago(data.filtroMetodosPago);
      this.actionSetDataserviciosIntegrales(data.listaServiciosIntegrales);
      this.actionSetDataTarifaContrato(data.filtroTarifaContrato);
      this.actionSetListaProductosExportar(data.listaProductosExportar);
      this.actionSetListaShipper(data.listaShippers);
      this.actionSetListaPacking(data.listaPackings);
      this.actionSetListaDireccionesShipper(data.listaDireccionesShippers);
      this.actionSetListaConsignatarios(data.listarConsignatarios);
      this.actionSetListaNotificados(data.listarNotificados);
      this.actionSetListaAtmosferas(data.listaAtmosferas);
      this.actionSetShippers(data.shippers);
    },
    validacionFormulario() {
      if (this.isAdmin) {
        if (
          Object.keys(this.formulario.anioModel).length > 0 &&
          Object.keys(this.formulario.semanaModel).length > 0 &&
          Object.keys(this.formulario.empresa).length > 0 &&
          Object.keys(this.formulario.contenedoresModel).length > 0 &&
          Object.keys(this.formulario.cantidadContenedoresModel).length > 0 &&
          Object.keys(this.formulario.puertosModel).length > 0
        ) {
          
          if( this.formulario.cantidadContenedoresModel == 0 ){
            return this.$vToastify.error( "Se debe agregar una cantidad de contenedores mayor a 0", "Error" );
          }
          if( this.formulario.cantidadContenedoresModel < 0 ){
            return this.$vToastify.error( "No se admiten valores negativos", "Error" );
          }
          this.actionSetFormularioSolicitudNoPlanificada(this.formulario);
          this.actionSetEstadoSolicitudReservaPlanificada(false);
          this.actionSetEstadoSolicitudReservaPlanificada(true);


          //

          this.ActionSetZindexModal(true);
        }

      } else {

        if (
          Object.keys(this.formulario.anioModel).length > 0 &&
          Object.keys(this.formulario.semanaModel).length > 0 &&
          Object.keys(this.formulario.contenedoresModel).length &&
          Object.keys(this.formulario.cantidadContenedoresModel).length > 0 &&
          Object.keys(this.formulario.puertosModel).length
        ) {

          if( this.formulario.cantidadContenedoresModel == 0 ){
            return this.$vToastify.error( "Se debe agregar una cantidad de contenedores mayor a 0", "Error" );
          }

          if( this.formulario.cantidadContenedoresModel < 0 ){
            return this.$vToastify.error( "No se admiten valores negativos", "Error" );
          }
          
          this.actionSetFormularioSolicitudNoPlanificada(this.formulario);
          this.actionSetEstadoSolicitudReservaPlanificada(false);
          this.actionSetEstadoSolicitudReservaPlanificada(true);
        } else {
          // this.actionSetFormularioSolicitudNoPlanificada();
          this.actionSetEstadoSolicitudReservaPlanificada(false);
        }
      }
    },
  },

  created() {
    this.getDataFormulario();
  },
};
</script>
